import api from '../../components/api'
import { LegacyJobData, TimesheetGpsData, UpdateJobRequest, UpdateVisitRequest, Visit } from './jobs'

export const getVisits = async (jobId: number): Promise<Visit[]>=> {
  return (await api.get(`/jobs/${jobId}/visits`)).data
}

export const getVisitsGpsData = async (visitId: string | undefined): Promise<TimesheetGpsData[]>=> {
  return (await api.get(`/v2/time/sheets/gps?timecardId=${visitId}`)).data.data
}

export const deleteVisit = async (visitId: string, deletePayrollTime: boolean) => {
  return api.delete(`/web/visits/${visitId}?deletePayrollTime=${deletePayrollTime}`)
}

export const updateVisit = async (request: UpdateVisitRequest) => {
  return api.put(`/web/visits`, request)
}

export const deleteJobCheck = async (jobId: number): Promise<boolean> => {
  return (await api.get(`/web/jobs/${jobId}/delete-check`)).data.canJobBeDeleted
}

export const deleteJob = async (jobId: number) => {
  return api.delete(`/web/jobs/${jobId}`)
}

export type ArchiveJobCheck = {
  jobFound: boolean
  canArchive: boolean
  isArchived: boolean
  archivedAtUtc?: string | null
  archivedBy?: string | null
  openInvoiceCount: number
  unsubmittedTimesheetCount: number
  message?: string | null
}

export type ArchiveJobMutationResult = {
  wasSuccessful: boolean
  jobFound: boolean
  message?: string | null
}

export const archiveJobCheck = async (jobId: number): Promise<ArchiveJobCheck> => {
  return (await api.get(`/web/jobs/${jobId}/archive-check`)).data
}

export const archiveJob = async (jobId: number): Promise<ArchiveJobMutationResult> => {
  return (await api.post(`/web/jobs/${jobId}/archive`)).data
}

export const unarchiveJob = async (jobId: number): Promise<ArchiveJobMutationResult> => {
  return (await api.post(`/web/jobs/${jobId}/unarchive`)).data
}

export const getJobUrl = async (jobId: number) => {
  return (await api.get(`/web/jobs/${jobId}/url`)).data.url
}

export const loadLegacyJobData = async (jobId: number): Promise<LegacyJobData> => {
  return (await api.get(`/jobs/${jobId}`)).data
}

export const updateJob = async (request: UpdateJobRequest): Promise<LegacyJobData> => {
  return (await api.post('/jobs', request)).data
}

export type PrintJobReportRequest = {
  routeSegment: string
  jobUrl: string
  workareas: Record<string, boolean>
}

export const printJobReport = async (request: PrintJobReportRequest): Promise<string> => {
  const response = await api.post(`/${request.routeSegment}/${request.jobUrl}/print/upload`, request.workareas)
  return response.data.url
}
